'use client';
import GlobalError from '@whelk/components/src/GlobalError';

export default GlobalError;
